/* DC — ouverture du mega-menu sans survol.
   Horizon n'ouvre le sous-menu qu'au survol (aria-expanded pose par le theme).
   Sur tablette / ecran tactile il n'y a pas de survol : le premier appui suivait
   directement le lien vers /collections. Ici, 1er appui = ouvrir, 2e appui = suivre le lien. */
(function () {
  if (window.__dcMenuTap) return;
  window.__dcMenuTap = 1;

  /* sans survol OU largeur tablette (couvre aussi une fenetre de bureau retrecie) */
  var mq = window.matchMedia('(hover: none), (max-width: 1024px)');
  var SEL = '.menu-list__link[aria-haspopup="true"]';

  function fermerTout(sauf) {
    document.querySelectorAll(SEL + '[aria-expanded="true"]').forEach(function (a) {
      if (a === sauf) return;
      a.setAttribute('aria-expanded', 'false');
      var li = a.closest('.menu-list__list-item');
      var s = li && li.querySelector('.menu-list__submenu');
      if (s) s.removeAttribute('data-active');
    });
  }

  /* capture : on passe avant le gestionnaire du theme */
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    var lien = e.target.closest && e.target.closest(SEL);
    if (!lien) return;
    var li = lien.closest('.menu-list__list-item');
    var sous = li && li.querySelector('.menu-list__submenu');
    if (!sous) return;

    /* deja ouvert : on laisse la navigation se faire normalement */
    if (lien.getAttribute('aria-expanded') === 'true') return;

    e.preventDefault();
    e.stopPropagation();
    fermerTout(lien);
    lien.setAttribute('aria-expanded', 'true');
    sous.setAttribute('data-active', '');
  }, true);

  /* clic en dehors */
  document.addEventListener('click', function (e) {
    if (!mq.matches) return;
    if (e.target.closest && e.target.closest('.menu-list__submenu, ' + SEL)) return;
    fermerTout(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermerTout(null);
  });

  /* retour en mode bureau : on nettoie l'etat ouvert */
  mq.addEventListener('change', function () { if (!mq.matches) fermerTout(null); });
})();
